import EnhancedModal from "../../../components/enhanced-modal";
import {MODAL_WIDTH_LG} from "../../../styles/constants";
import {Button} from "antd";
import React from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {hideDsdDetailHierarchicalCodelistsForSelector, setDsdDetailHierarchicalCodelistsForSelector} from "../actions";
import {reuseAction} from "../../../utils/reduxReuse";
import ArtefactList from "../../../components/artefact-list";

const mapStateToProps = (state, {instanceState}) => ({
  isHierarchicalCodelistsForSelectorVisible: instanceState.isHierarchicalCodelistsForSelectorVisible,
  hierarchicalCodelists: instanceState.hierarchicalCodelists,
});

const mapDispatchToProps = (dispatch, {instancePrefix}) => ({
  onHierarchicalCodelistsForSelectorHide: () => dispatch(reuseAction(hideDsdDetailHierarchicalCodelistsForSelector(), instancePrefix)),
  onHierarchicalCodelistsForSelectorSet: codelistUrn => dispatch(reuseAction(setDsdDetailHierarchicalCodelistsForSelector(codelistUrn), instancePrefix)),
});

const HierarchicalCodelistSelector = ({
                                t,
                                isHierarchicalCodelistsForSelectorVisible,
                                hierarchicalCodelists,
                                onHierarchicalCodelistsForSelectorHide,
                                onHierarchicalCodelistsForSelectorSet
                              }) =>
  <EnhancedModal
    visible={isHierarchicalCodelistsForSelectorVisible && hierarchicalCodelists !== null}
    width={MODAL_WIDTH_LG}
    title={t('reduxComponents.dsdDetail.hierarchicalCodelistsSelector.title')}
    onCancel={onHierarchicalCodelistsForSelectorHide}
    footer={<Button onClick={onHierarchicalCodelistsForSelectorHide}>{t('commons.buttons.close.title')}</Button>}
    withDataLanguageSelector
  >
    <ArtefactList
      artefacts={hierarchicalCodelists}
      onRowClick={({urn}) => onHierarchicalCodelistsForSelectorSet(urn)}
    />
  </EnhancedModal>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(HierarchicalCodelistSelector);
